import React, {useState, useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate, useNavigate} from 'react-router-dom';
import {Layout, Menu} from 'antd';
import {
    HomeOutlined,
    ExperimentOutlined,
    SettingOutlined,
    UserOutlined, PicCenterOutlined, PauseCircleFilled, VideoCameraFilled, BgColorsOutlined,
} from '@ant-design/icons';
import Login from './components/Login';
import Home from './components/Home';
import FormulaList from './components/FormulaList';
import AddFormula from './components/AddFormula';
import Settings from './components/Settings';
import UserManagement from './components/UserManagement';
import AppHeader from './components/Header';
// 使用安装的antd版本
import 'antd/dist/antd.min.css';
import './App.css';
import EditFormula from "./components/EditFormula";
import My from "./components/My";
import FirmwareUpgrade from "./components/FirmwareUpgrade";
import EquipmentVideosManagement from "./components/EquipmentVideosManagement";
import ColorWorksManagement from "./components/ColorWorksManagement";
import HairDyeManagement from "./components/HairDyeManagement";
import HairDyeStock from "./components/HairDyeStock";
import HairDyeSpecManagement from "./components/HairDyeSpecManagement";

const {Content, Sider} = Layout;

// 私有路由组件，用于鉴权
const PrivateRoute = ({children}) => {
    const isAuthenticated = localStorage.getItem('token') !== null;
    return isAuthenticated ? children : <Navigate to="/login"/>;
};

// 主布局组件
const MainLayout = ({children, defaultSelectedKey}) => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const handleMenuClick = (e) => {
        switch (e.key) {
            case '1':
                navigate('/home');
                break;
            case '2':
                navigate('/formulas');
                break;
            case '3':
                navigate('/settings');
                break;
            // case '4':
            //   navigate('/users');
            //   break;
            case '5':
                navigate('/firmware/upgrade');
                break;
            case '6':
                navigate('/equipment/videosManagement');
                break;
            case '7':
                navigate('/color/worksManagement');
                break;
            case '8':
                navigate('/hair-dye');
                break;
            default:
                navigate('/home');
        }
    };

    return (
        <Layout style={{minHeight: '100vh'}}>
            <AppHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed}/>
            <Layout style={{marginTop: 64}}>
                <Sider
                    trigger={null}
                    collapsible
                    collapsed={collapsed}
                    width={200}
                    collapsedWidth={isMobile ? 0 : 80}
                    className="site-sider"
                    style={{
                        overflow: 'auto',
                        height: 'calc(100vh - 64px)',
                        position: 'fixed',
                        left: 0,
                        top: 64,
                        bottom: 0,
                    }}
                >
                    <Menu
                        theme="dark"
                        mode="inline"
                        defaultSelectedKeys={[defaultSelectedKey]}
                        onClick={handleMenuClick}
                        items={[
                            {
                                key: '1',
                                icon: <HomeOutlined/>,
                                label: '首页',
                            },
                            {
                                key: '2',
                                icon: <ExperimentOutlined/>,
                                label: '配方管理',
                            },
                            {
                                key: '8',
                                icon: <BgColorsOutlined />,
                                label: '染膏管理',
                            },
                            // {
                            //   key: '3',
                            //   icon: <SettingOutlined />,
                            //   label: '系统设置',
                            // },
                            // {
                            //     key: '4',
                            //     icon: <UserOutlined/>,
                            //     label: '用户管理',
                            // },
                            {
                                key: '5',
                                icon: <PicCenterOutlined/>,
                                label: '固件升级',
                            },
                            {
                                key: '6',
                                icon: <VideoCameraFilled/>,
                                label: '商城教学视频',
                            },
                            {
                                key: '7',
                                icon: <PauseCircleFilled/>,
                                label: '商城优秀案例',
                            },
                        ]}
                    />
                </Sider>
                <Layout style={{marginLeft: collapsed ? (isMobile ? 0 : 80) : 200}}>
                    <Content style={{margin: '24px 16px', overflow: 'initial'}}>
                        {children}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login/>}/>

                <Route path="/home" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="1">
                            <Home/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/formulas" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="2">
                            <FormulaList/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/formulas/edit/:id" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="2">
                            <EditFormula/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/formulas/add" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="2">
                            <AddFormula/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/settings" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="3">
                            <Settings/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/my" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="3">
                            <My/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/users" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="4">
                            <UserManagement/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/firmware/upgrade" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="5">
                            <FirmwareUpgrade/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/equipment/videosManagement" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="6">
                            <EquipmentVideosManagement/>
                        </MainLayout>
                    </PrivateRoute>
                }/>


                <Route path="/color/worksManagement" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="7">
                            <ColorWorksManagement/>
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/hair-dye" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="8">
                            <HairDyeManagement />
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/hair-dye/stock/:dyeId" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="8">
                            <HairDyeStock />
                        </MainLayout>
                    </PrivateRoute>
                }/>

                <Route path="/hair-dye/specs/:dyeId" element={
                    <PrivateRoute>
                        <MainLayout defaultSelectedKey="8">
                            <HairDyeSpecManagement />
                        </MainLayout>
                    </PrivateRoute>
                }/>


                <Route path="/" element={<Navigate to="/home"/>}/>
                <Route path="*" element={<Navigate to="/home"/>}/>
            </Routes>
        </Router>
    );
}

export default App;
